// Maps a pepl-admin-bff SurveyDefinition to the flat row used by the list and grid views.
// Per the actual API response: surveyName is a top-level field; survey id is the 3P-provided
// partnerConfiguration.partnerSurveyId; source is sourcePartner. partnerSettings is freeform
// JSON (e.g. { theme, language }) and may carry a url, so surveyUrl reads it defensively.
export const mapSurveyToRow = (survey) => {
  const partnerConfiguration = survey?.partnerConfiguration || {};
  const partnerSettings = partnerConfiguration.partnerSettings || {};
  return {
    surveyName: survey?.surveyName || "",
    surveyId: partnerConfiguration.partnerSurveyId || "",
    source: survey?.sourcePartner || "",
    surveyUrl: partnerSettings.url || "",
    original: survey,
  };
};
